import type { PerformanceCoreDatapoint, PerformanceDatapoint } from 'owa-analytics';

type SearchEndToEndDatapoint = PerformanceDatapoint | PerformanceCoreDatapoint;

let inFlightDatapoint: SearchEndToEndDatapoint | undefined;

/**
 * Tracks the latest mail SearchEndToEnd datapoint. If a previous one is still in flight
 * and has no outcome stamped, it is marked Abandoned and invalidated (never logged) so it is not
 * later reported as a 60s Timeout. The stamp lets stale handlers recognize it as superseded.
 */
export default function trackSearchEndToEndDatapoint(datapoint: SearchEndToEndDatapoint): void {
    const previous = inFlightDatapoint;
    inFlightDatapoint = datapoint;

    if (
        !previous ||
        previous === datapoint ||
        previous.isSent() ||
        previous.hasCustomData('searchOutcome')
    ) {
        return;
    }

    previous.addCustomData({ searchOutcome: 'Abandoned', abandonReason: 'Superseded' });
    previous.invalidate();
}

export function resetTrackedSearchEndToEndDatapointForTest(): void {
    inFlightDatapoint = undefined;
}
